import ActiveRecord from './active_record/base'

class TeamTemplateDay extends ActiveRecord {
	static tableName = 'teamTemplateDays'
}

export default TeamTemplateDay
